@if(mode==="read"){
  <div>
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="gridData"
      [disableSelection]="true" [cols]="gridCols" [gridTitle]="false" [pagination]="true" [loadPage]="false"
      (gridAction)="action($event)" [actionButtons]="actions" [pagination]="false">
    </ppl-list-table>
  </div>
  @if (restoreRehireApiError) {
    <div class="w-100 alert alert-danger d-flex justify-content-between align-items-center">
      <span style="font-size: 16px;">{{ restoreRehireApiError }}</span>
    </div>
  }
  @if ((isSectionEditable && allowMultiple) || showChangeEorButton) {

  <div class="actions-container">
    <!-- sectionName === 'independent_provider' && -->
    <ppl-button [label]="'Search'" icon="fa fa-magnifying-glass" [customClass]="'ghost-button'" [iconPosition]="'left'"
      (click)="searchAssociation()"></ppl-button>
    @if (isSectionEditable && allowMultiple) {
    <ppl-button [label]="addBtnLabel" icon="fa fa-plus" [customClass]="'ghost-button'" [iconPosition]="'left'"
      (click)="addAssociation()"></ppl-button>
    }
    @if (showChangeEorButton) {
    <ppl-button [label]="'Change EOR'" icon="fa fa-exchange" [customClass]="'ghost-button'" [iconPosition]="'left'"
      (click)="changeEor()"></ppl-button>
    }
  </div>
  }
}

@if (mode === 'search') {
  <ppl-provider-search-and-select [providerType]="providerType" [allAssociations]="allAssociations"
    [disabledRelationshipCodes]="disabledTaskManagerCodes"
    (providerSelected)="handleProviderSelected($event)"
    (cancel)="handleCancelSearch()" (addingNewProvider)="handleAddNewProvider()">
  </ppl-provider-search-and-select>
}

@if(mode ==='edit' || mode === 'add'){
  <div class="ppl-mt20">
    <ppl-add-association-form [sectionName]="sectionName" [providerId]="selectedProviderToAdd()?.providerId ?? null"
      (formUpdated)="handleFormUpdate($event)" [validationErrors]="validationErrors" [readonly]="readOnly" [providerType]="selectedProviderType" [partiProviderAssocId]="selectedPartiProviderAssocId"
      [disabledTaskManagerCodes]="disabledTaskManagerCodes">
    </ppl-add-association-form>
  </div>

  <div class="custom-row">
    @if(mode==="edit" || mode === 'add'){
      <ppl-button [label]="formReadonly ? 'Close' : 'Cancel'" icon="fa fa-ban" [customClass]="'alt-button'"
        [iconPosition]="'left'" (click)="cancelEdit()"></ppl-button>
      @if(!formReadonly) {
      <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
        (click)="save()"></ppl-button>
      }
    }
  </div>
}
<div class="filter-panel">
  <ng-template #confirmationDialog let-cancel="cancel">
    <div class="p-10">
      <form nz-form [formGroup]="disassociationForm">
        <div nz-row>
          <div nz-col style="margin-left: 8px; margin-right: 8px; width: 100%;">
            <nz-form-item>
              <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label">
                Disassociation Date <span>*</span>
              </nz-form-label>
              <nz-form-control>
                <ppl-date-picker formControlName="disassociationDate"
                  [placeholder]="'Disassociation Date'"
                  [styleClass]="disassociationFormErrors['disassociationDate'] ? 'error' : ''">
                </ppl-date-picker>
                @if (disassociationFormErrors['disassociationDate']) {
                  <div nz-form-explain class="error-message">{{ disassociationFormErrors['disassociationDate'] }}</div>
                }
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        @if (showDisassociationReason) {
          <div nz-row>
            <div nz-col style="margin-left: 8px; margin-right: 8px; width: 100%;">
              <nz-form-item>
                <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label">
                  Disassociation Reason <span>*</span>
                </nz-form-label>
                <nz-form-control>
                  <div class="ppl-select" [ngClass]="{'error': disassociationFormErrors['disassociationReason']}">
                    <ppl-dropdown-select formControlName="disassociationReason"
                      placeholder="Disassociation Reason"
                      [options]="disassociationReasonList"
                      [optionLabel]="'lkpValueName'"
                      [optionValue]="'lkpValueCode'">
                    </ppl-dropdown-select>
                  </div>
                  @if (disassociationFormErrors['disassociationReason']) {
                    <div nz-form-explain class="error-message">{{ disassociationFormErrors['disassociationReason'] }}</div>
                  }
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
        }
      </form>
      @if (disassociationApiError) {
        <div class="w-100 alert alert-danger d-flex justify-content-between align-items-center">
          <span style="font-size: 16px;">{{ disassociationApiError }}</span>
        </div>
      }
      <nz-alert
        nzType="info"
        [nzMessage]="disassociationInfoMessage"
        nzShowIcon>
      </nz-alert>
      <ng-template #disassociationInfoMessage>
        <div>You are initiating your provider's disassociation. Please ask that they submit any unsubmitted time entries for payment.</div>
        <div>This provider will not be able to submit dates of service worked on or after the disassociation date you selected below.</div>
        <div>If the provider is in a disassociation status, the provider has up to 30 days from the disassociation date to submit any remaining timesheets for payment before your employment relationship is no longer active.</div>
      </ng-template>
      <div class="custom-row">
        <ppl-button label="Cancel" [customClass]="'secondary'" [size]="'large'" (click)="cancel()"></ppl-button>
        <ppl-button label="Disassociate" [customClass]="'primary'" [size]="'large'" (click)="onDisassociate(cancel)"></ppl-button>
      </div>
    </div>
  </ng-template>
</div>

<div class="filter-panel">
  <ng-template #deleteConfirmationDialog let-cancel="cancel">
    <p> Participants under the age of 18 are required to have at least one Designated Representative. </p>
    <p> Please add a new Designated Representative before removing the existing one.</p>
  </ng-template>
</div>

<div class="filter-panel">
  <ng-template #employerRestrictionDialog>
    <p>Disassociation is not allowed. The Participant/Employer association is in Paperwork Complete status.</p>
  </ng-template>
</div>